import { Component, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FilterFieldComponent } from '../filter-field.component';
import { TabbedFilterField } from './filter-field-tabbed';

export type TabFilterTheme = 'gradient' | 'plain';

@Component({
  selector: 'va-filter-tabbed',
  template: `
    <div [ngClass]="getThemeClasses()">
      <h3 *ngIf="filterField.name?.length > 0" class="page-title">{{ '' + filterField.name | translate }}</h3>
      <mat-tab-group (selectedTabChange)="changeTab($event)" [selectedIndex]="selectedIndex">
        <ng-container *ngIf="useCustomCase; else UpperCase">
          <mat-tab
            *ngFor="let tab of filterField.options"
            [label]="'' + (filterField.disableTranslation ? tab.name : (tab.name | translate))"
          ></mat-tab>
        </ng-container>
        <ng-template #UpperCase>
          <mat-tab
            *ngFor="let tab of filterField.options"
            [label]="('' + tab.name).toUpperCase() | translate"
          ></mat-tab>
        </ng-template>
      </mat-tab-group>
    </div>
  `,
  styleUrls: ['filter-field-tabbed.component.scss'],
})
export class TabbedFilterFieldComponent extends FilterFieldComponent<TabbedFilterField> {
  @Input() useCustomCase = false;
  @Input() theme: TabFilterTheme = 'gradient';
  changeTab(event: MatTabChangeEvent): void {
    const tab = this.filterField.options[event.index];
    this.applyFilter(tab);
  }

  get selectedIndex(): number {
    if (this.filterField.value) {
      return this.filterField.options.findIndex((tab) => tab.id === this.filterField.value!.id);
    }
    return 0;
  }

  getThemeClasses(): string {
    switch (this.theme) {
      case 'gradient':
        return 'tab-container gradient';
      case 'plain':
        return 'plain';
    }
  }
}
